import React from 'react';

import { SlicePage } from '../../components/SlicePage';
import { SCAN_VIEWS } from '../../consts';

export const C = () => {
  return <SlicePage scanView={SCAN_VIEWS.C} />;
};
